import * as yup from 'yup';

export const transcriptSchema = yup.object({
  Transcript: yup
    .array(
      yup.object({
        BeginOffsetMillis: yup.number().required(),
        Content: yup.string().required(),
        EndOffsetMillis: yup.number().required(),
        ParticipantId: yup.string().required(),
      }),
    )
    .required(),
});
